import React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { motion } from 'framer-motion';

import HeaderPanel from '../Components/HeaderPanel';
import CardOfCase from '../Components/CardOfCase';
import Search from '../Components/Search';
import InfoBlock from '../Components/InfoBlock';

import LoadingLines from '../Components/LoadingLines';

import headerPanel from '../styles/HeaderPanel.module.css';

const Complaints = () => {
    const [cases, setCases] = React.useState([]);
    const [warning, setWarning] = React.useState('');
    const [loading, setLoading] = React.useState(true);
    const [reload, setReload] = React.useState(true);

    const [idCaseForModal, setIdCaseForModal] = React.useState('');
    const [isCardOfCaseModal, setIsCardOfCaseModal] = React.useState(false);
    const [isSearch, setIsSearch] = React.useState(false);

    React.useEffect(() => {
        const token = localStorage.getItem('token');
        axios.get('/api/cases-one-category?label=Жалобы', {
            headers: {
                Authorization: `Bearer ${token}`,
            }
        })
        .then(response => {
            if (response.data.length === 0) {
                setWarning('Таблица жалоб пуста.');
                setCases([]);
            } else {
                setWarning('');
                setCases(response.data);
            }
        })
        .catch(error => {
            setWarning(`Ошибка при загрузке таблицы жалоб:  ${error.response?.data.message || error.message}`);
        })
        .finally(() => {
            setLoading(false);
        });
    }, [reload]);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        const day = String(date.getDate()).padStart(2, '0');
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const year = date.getFullYear();
        return `${day}.${month}.${year}`;
    };
    const formatComment = (comment) => {
        if (comment === 'Заметка отсутствует') {
            return <span style={{color: 'rgb(169, 169, 169)'}}>{comment}</span>
        }else {
            const truncatedComment = comment.length > 120 ? comment.substring(0, 120) + '...' : comment;
            return <span>{truncatedComment}</span>;
        }
    };

    // Функция для покраски просроченных дел в списке
    const getCaseStyle = (caseItem) => {
        const todayMSC = new Date();
        todayMSC.setHours(todayMSC.getHours() + 3); // Перевод времени в МСК
    
        const isPastEndDate =
            new Date(caseItem.date_end) < todayMSC && caseItem.status !== 'Завершено';
    
        if (isPastEndDate) {
            return { border: '1px solid rgb(255, 14, 14)', backgroundColor: 'rgb(255, 247, 247)' };
        }
    };

    return (
        <>
            {isCardOfCaseModal && <CardOfCase closeModal={() => {setIsCardOfCaseModal(false)}} id={idCaseForModal} onCardOfCaseSuccess={() => {setReload(true)}} />}
            {isSearch && <Search closeModal={() => {setIsSearch(false)}} type={'Жалобы'} />}

            <div className='mainContainer'>
                <InfoBlock />
                <h1>Жалобы</h1>
                <HeaderPanel typePanel='Администратор' />
                <div className={headerPanel.additionalPanel}>
                    <div className={headerPanel.searchBtn} onClick={(e) => {e.preventDefault(); setIsSearch(true)}}>Поиск по номеру...</div>

                    <Link to='/inbox' className='button' style={{marginRight: '4px'}}>Уведомления</Link>
                </div>
                <motion.div
                    initial={{ scale: '97%', opacity: 0 }}
                    animate={{ scale: '100%', opacity: 1 }}
                    exit={{ scale: '97%', opacity: 0 }}
                    transition={{ duration: 0.3 }}
                >
                    <div className='table-container'>
                        <div className='tableHeader'>
                            <a className='numberCase'>Номер</a>
                            <a className='categoryCase'>Этап</a>
                            <a className='applicantCase'>Истец</a>
                            <a className='commentsCase'>Комментарий</a>
                            <a className='datesCase'>Начальная дата / Конечная дата</a>
                            <a className='statusCase'>Статус</a>
                        </div>
                        {loading && <LoadingLines />}
                        {warning && <div className='case warningLine'><a>{warning}</a></div>}
                        {cases.map((caseItem) => (
                            <div className='case' key={caseItem.id} style={getCaseStyle(caseItem)}  onClick={() => {setIsCardOfCaseModal(true); setIdCaseForModal(caseItem.id)}}>
                                <a className='numberCase'>{caseItem.number}</a>
                                <a className='categoryCase'>{caseItem.status=="В работе" ? (caseItem.current_phase) : (<>Дело завершено</>)}</a>
                                <a className='applicantCase'>{caseItem.applicant}</a>
                                <a className='commentsCase'>{formatComment(caseItem.comments)}</a>
                                <a className='datesCase'>{formatDate(caseItem.date_start)} / {formatDate(caseItem.date_end)}</a>
                                <a className='statusCase' style={{borderBottom: 'none', borderRight: 'none'}}>{caseItem.status}</a>
                            </div>
                        ))}
                    </div>
                </motion.div>
            </div>
        </>
    )
}

export default Complaints;